import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import {
  CheckoutPage,
  CheckoutTitleSection,
  ContactInformationReview,
  PassengerReview,
} from "@components/checkout";
import { ParentState } from "@hopper-b2b/checkout";
import {
  FlightExchangePriceBreakdown,
  useFlightCheckoutHeaderSteps,
  useFlightExchangeReviewPage,
} from "@hsbc/flights";
import {
  CheckoutStepHeader,
  TermsAndConditionsConfirmation,
} from "@hsbc/portal";

import { FlightExchangeTripDetailsCard } from "@tenant/flights";
import styles from "./styles.module.scss";

export const FlightExchangeReviewPage = () => {
  const [block, cn] = useModuleBEM(styles, CoreFlightsComponent.ReviewPage);
  const {
    context: { contactInfo, passengers, termsAccepted },
    handlers: { handleContinue, onTermsAndConditionsClick },
    text,
  } = useFlightExchangeReviewPage();

  const checkoutHeaderSteps = useFlightCheckoutHeaderSteps();

  return (
    <CheckoutPage
      title={text.checkoutTitle}
      className={block}
      bottomSection={
        <button
          disabled={termsAccepted === false}
          className={cn("book-button", { disabled: termsAccepted === false })}
          onClick={handleContinue}
        >
          {text.confirmAndBook}
        </button>
      }
    >
      <div className={cn("section")}>
        <CheckoutStepHeader
          steps={checkoutHeaderSteps}
          currentStep={ParentState.review}
        />
      </div>

      <CheckoutTitleSection
        title={text.reviewTitle}
        subtitle={text.reviewSubtitle}
        className={cn("title-section")}
      />

      <div className={cn("section")}>
        <FlightExchangeTripDetailsCard />
      </div>

      <div className={cn("section")}>
        <PassengerReview passengers={passengers} />
      </div>

      <div className={cn("section")}>
        <ContactInformationReview
          email={contactInfo?.email ?? ""}
          phone={contactInfo?.phoneNumber ?? ""}
        />
      </div>

      <div className={cn("section")}>
        <FlightExchangePriceBreakdown />
      </div>

      <div className={cn("terms-and-conditions-section")}>
        <TermsAndConditionsConfirmation
          onTermsClick={onTermsAndConditionsClick}
          termsAccepted={termsAccepted}
        />
      </div>
    </CheckoutPage>
  );
};
